export const getwayControl = {
  queryAreaDeviceTree: '/bms/device/queryAreaDeviceTree.json', // 根据设备类型查询区域设备树
  queryDeviceSceneList: '/bms/devicescene/queryDeviceSceneList.json', // 左侧列表
  queryDeviceScenePlanList: '/bms/devicescene/queryDeviceScenePlanList.json', //值守方案
  queryDeviceScenePlanDetail: '/bms/devicescene/queryDeviceScenePlanDetail.json', //值守方案详情
  addDeviceScenePlan: '/bms/devicescene/addDeviceScenePlan.json', //新增方案
  updateDeviceScenePlan: '/bms/devicescene/updateDeviceScenePlan.json', //修改方案
  queryDeviceSceneDetail: '/bms/devicescene/queryDeviceSceneDetail.json', // 右侧详情
  getPersonRecordList: '/bas/turnstilegate/queryTurnstilegateTrafficRecordList.json', // 获取人员通行记录列表
  getVehicleRecordList: '/bas/vehicleBarrier/queryVehicleBarrierTrafficRecordList.json',
  // queryVehicleBarrierControlRecordList: '/bas/vehicleBarrier/queryVehicleBarrierControlRecordList.json',
  queryVehicleBarrierControlRecordList: '/bas/vehicleBarrier/queryVehicleBarrierControlRecordListApi.json',
  deleteDeviceScene: '/bms/devicescene/deleteDeviceScene.json', // 删除
  deleteDeviceScenePlan: '/bms/devicescene/deleteDeviceScenePlan.json', // 删除
  updateDeviceScene: '/bms/devicescene/updateDeviceScene.json', // 删除
  addDeviceScene: '/bms/devicescene/addDeviceScene.json', // 添加场景
  batchControlVehicleBarrier: '/bas/vehicleBarrier/batchControlVehicleBarrier.json', // 控制开关
  addDefaultBwlist: '/vas/vehicleRepositories/addDefaultBwlist.json', // 将车辆加入黑名单
  deleteBwlist: '/vas/vehicleRepositories/deleteBwlist.json', // 将车辆移出黑名单
  queryPassVehicleRecordList: '/bas/vehicleBarrier/queryVehicleBarrierPassVehicleRecordList.json', // 过车记录
  queryVehicleRecordDetail: '/bas/vehicleBarrier/queryVehicleBarrierPassVehicleRecordDetail.json', // 过车记录
  getDeviceListByPage: '/bms/device/getDeviceListByPageApi.json', // 查询设备列表

  controlTurnstilegate: '/bas/turnstilegate/controlTurnstilegate.json', //开关控制门--人行闸机
  controlVehicleBarrier: '/bas/vehicleBarrier/controlVehicleBarrier.json', // 控制开关--道闸
  manualRemoteCall: '/bas/remotecall/manualRemoteCall.json', // 远程喊话
}
